import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <div>
        <footer className="page-footer font-small mdb-color pt-4 border-top">
          <div className="">
            <div className=" mx-3 text-center text-md-left">
              <div className="row text-center text-md-left mt-3 pb-3">
                <div className="col-md-3 col-lg-3 col-xl-3 mx-auto mt-3">
                  <h6 className="text-uppercase mb-4 font-weight-bold">
                    Rebuild Construction Services
                  </h6>
                  <p>
                    We provide our high-quality fences to assure the efficient
                    execution of your project. Exceeding your expectations is
                    our chief goal.
                  </p>
                </div>

                <hr className="w-100 clearfix d-md-none" />

                <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mt-3">
                  <h6 className="text-uppercase mb-4 font-weight-bold">
                    Useful links
                  </h6>
                  <p>
                    <a href="/">Home</a>
                  </p>
                  <p>
                    <a href="/about">About</a>
                  </p>
                  <p>
                    <a href="/services">Services</a>
                  </p>
                  <p>
                    <a href="/contact">Contact</a>
                  </p>
                </div>

                <hr className="w-100 clearfix d-md-none" />

                <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
                  <h6 className="text-uppercase mb-4 font-weight-bold">
                    Contact
                  </h6>

                  <p style={{ color: "rgb(14,35,87)" }}>
                    <span style={{ width: "300px", whiteSpace: `nowrap` }}>
                      <i className="fas fa-home mr-3 regularNavLink "> </i>
                      <span>Suite 1, Ground Floor</span>
                    </span>
                    <br />
                    <span style={{ paddingLeft: "35px" }}>
                      200 Malop Street
                    </span>
                    <br />
                    <span style={{ paddingLeft: "35px" }}>
                      Geelong VIC 3220
                    </span>
                  </p>

                  <p>
                    <a href="mailto:admin@rebuildcs.com.au">
                      <i className="fas fa-envelope mr-3 regularNavLink"></i>{" "}
                      admin@rebuildcs.com.au
                    </a>
                  </p>
                  <p>
                    <a href="tel:0456 886 443">
                      <i className="fas fa-phone mr-3 regularNavLink"></i>
                      0456 886 443
                    </a>
                  </p>
                </div>
              </div>

              <hr />

              <div className="row ">
                <div className="col-md-12 text-center">
                  <p>
                    © 2020 Copyright:
                    <a href="https://rebuildcs.com.au/">
                      <strong> Rebuild Construction Services </strong>
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}
